import { TZDateFunct } from '@/utils/ZDateFunct'
export default
{
  mounted()
  {
    document.addEventListener("dblclick", (event) => {
      if (event.target.tagName == "INPUT" && (event.target.type == "date"))
      {
        event.target.value = TZDateFunct.FormatDateTime("yyyy-mm-dd", new Date());
        event.target.dispatchEvent(new Event("input"));
      }        
      if (event.target.tagName == "INPUT" && (event.target.type == "datetime-local"))
      {
        event.target.value = TZDateFunct.FormatDateTime("yyyy-mm-ddThh:nn", new Date());
        event.target.dispatchEvent(new Event("input"));
      }
    }, true);
  },
}